import cn from 'classnames';
import Image from 'next/image';
import Button from '@/components/Button';
import { placeholderImageUrl } from '@/lib/constants';

type Props = {
  img: string;
  title: string;
  type: 'warehouse' | 'fulfillment';
  href: string;
};

export default function CooperateWarehouseFulfillBanner({
  img,
  title,
  type,
  href,
}: Props) {
  return (
    <section className="bg-secondary-10 desktop:grid-cols-2 grid grid-cols-1 gap-x-3 bg-[url('/static/icons/service/CooperateServiceBannerVector.svg')]">
      <div className="desktop:py-36 desktop:pr-20 col-span-1 flex justify-end py-6">
        <article className="desktop:max-w-[532px] desktop:space-y-6 flex flex-col justify-center space-y-4 px-4">
          <h2 className="text-title32 text-neutral-90 desktop:text-title42 font-bold">
            {title}
          </h2>
          <div>
            <Button type="link" href={href}>
              Nhận tư vấn ngay
            </Button>
          </div>
        </article>
      </div>
      <div className="desktop:pr-14 desktop:py-20 relative col-span-1 flex items-center justify-center overflow-hidden">
        <div
          className={cn('relative h-auto w-full bg-transparent', {
            'aspect-[163/100]': type === 'fulfillment',
            'aspect-[253/171]': type === 'warehouse',
          })}
        >
          <Image
            src={img || placeholderImageUrl}
            alt="Cooperate warehouse"
            fill
            className="z-20"
          />
          <div className="bg-primary-50 desktop:h-28 desktop:w-52 desktop:-bottom-8 desktop:left-16 absolute -bottom-0 left-8 h-14 w-28 rounded-t-full"></div>
          <div className="bg-yellow-30 desktop:-right-40 desktop:h-28 desktop:w-52 desktop:-top-8 absolute top-2 -right-8 h-14 w-28 rounded-t-full"></div>
        </div>
      </div>
    </section>
  );
}
